export const SEARCH_RESULT_CLICK_LABEL = 'sst_click_general_search_result';
export const SEARCH_RESULT_CLICK_EMAIL_LABEL = 'sst_click_general_search_email_copying';
export const INACTIVE_LABEL = 'INACTIVE';
export const PRIMARY_LABEL = 'PRIMARY';
